<template>
  <div class="card card-body rounded-top">
    <component-table
      actionsWidth="215px"
      entityType="mail_template"
      :columns="table.columns"
      :data="list"
      :actions="table.actions"
      :total="count"
      @add="goToAddPage"
      @edit="goToEditPage($event.id)"
      @delete="showDeleteDialog($event.id)"
      @view="goToProfile($event.id)"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ComponentTable from '@/components/table/Table';
import { DEFAULT_TABLE_ACTIONS } from '@/utils/constants';
import { address } from '@/filters/address';
import { listMixin } from '@/mixins/list';

const messages = {
  listError: 'messages.mailTemplate.listError',
  getError: 'messages.mailTemplate.getError',
  added: 'messages.mailTemplate.added',
  addError: 'messages.mailTemplate.addError',
  updated: 'messages.mailTemplate.updated',
  updateError: 'messages.mailTemplate.updateError',
  deleted: 'messages.mailTemplate.deleted',
  deleteConfirm: 'messages.mailTemplate.deleteConfirm',
  deleteError: 'messages.mailTemplate.deleteError'
};

// @vuese
// Lista szablonów
// @group MailTemplate
export default {
  mixins: [listMixin('mailTemplate', messages)],
  components: { ComponentTable },
  data: () => ({
    table: {
      columns: [{ name: 'name', displayName: 'columns.name', sortable: true }],
      actions: DEFAULT_TABLE_ACTIONS
    }
  }),
  methods: {
    // Przenosi do formularza dodawania szablonu
    goToAddPage() {
      this.$router.push({ name: 'mailTemplateAdd' });
    },
    // Przeniesienie na stronę edycji szablonu
    goToEditPage(mailTemplateId) {
      this.$router.push({ name: 'mailTemplateEdit', params: { mailTemplateId } });
    }
  }
};
</script>
